/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { partnersControllerGetPartners } from '../fn/partners-controller/partners-controller-get-partners';
import { PartnersControllerGetPartners$Params } from '../fn/partners-controller/partners-controller-get-partners';
import { PartnersListResponseGetRecordsList } from '../models/partners-list-response-get-records-list';


/**
 * Represents an API resource related to customers / partners / installers.
 */
@Injectable({ providedIn: 'root' })
export class PartnersControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `partnersControllerGetPartners()` */
  static readonly PartnersControllerGetPartnersPath = '/planning-projects/v1/partners';

  /**
   * Gets a list of partners (customers/installers) for the
   *         given request criteria - using search string and sales organization code.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `partnersControllerGetPartners()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnersControllerGetPartners$Response(params: PartnersControllerGetPartners$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnersListResponseGetRecordsList>> {
    return partnersControllerGetPartners(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a list of partners (customers/installers) for the
   *         given request criteria - using search string and sales organization code.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `partnersControllerGetPartners$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnersControllerGetPartners(params: PartnersControllerGetPartners$Params, context?: HttpContext): Observable<PartnersListResponseGetRecordsList> {
    return this.partnersControllerGetPartners$Response(params, context).pipe(
      map((r: StrictHttpResponse<PartnersListResponseGetRecordsList>): PartnersListResponseGetRecordsList => r.body)
    );
  }

}
